export class Dataset {

    idDataset: number;
    idProjeto: number;
    idTenant: number;
    comando: string;
    nome: string;
    dataFieldsJson: string;
    nomeProjeto: string;
    nomeTenant: string;
    resultadoComplexo: boolean;
    scriptCsharp: boolean;
    dadosdaUrl: boolean;
    url: string;
    idAutorizacao: number;
    token: string;
}
